import {makeAutoObservable} from 'mobx';
import {getTime} from "html-evaluate-utils/DateFormat";
import axios from "axios";
import {API_URL, CFG_BY_USER_ID, SAVE_CFG} from "clicker-common/src/Config";
import {DEV_MODE} from "./Config";
import {lc_user_cfg} from "../static/lc_user_cfg";

export class CfgState {

    authState = null;
    rootCfg= null;
    dataLoaded = false;

    constructor() {
        makeAutoObservable(this);
    }

    setup(authState, caller) {
        console.log(getTime() + " CfgState.setup() <-" + caller);
        this.authState = authState;
        this.setRootCfg(lc_user_cfg, " CfgState.setup() <-" + caller);
       // this.setRootCfg({
         //   "uid" : 0,
           // "cfg" : lc_user_cfg});
    }

    setRootCfg(rootCfg, caller){
        console.log(getTime() + " CfgState.setRootCfg() <-" + caller);
        this.rootCfg = rootCfg;
    }

    setIgnoredActors(newIgnoredActors){
        this.rootCfg.cfg.linkedInLike.ignoredActor = newIgnoredActors;
    }

    setFriendActors(newFriendActor){
        this.rootCfg.cfg.linkedInLike.friendActor = newFriendActor;
    }

    setLikeCounterValue(value){
        this.rootCfg.cfg.linkedInLike.like.likeCounterValue = value;
    }

    setRepostCounterValue(value){
        this.rootCfg.cfg.linkedInLike.repost.likeCounterValue = value;
    }

    setDailyLimitValue(actionKey, value) {
        const parsed = parseInt(value, 10);
        this.rootCfg.cfg.linkedInLike[actionKey].dailyLimit = Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    }

    setActionRun(actionKey, value) {
        this.rootCfg.cfg.linkedInLike[actionKey].run = !!value;
    }

    setActionWitRun(actionKey, value) {
        if (!this.rootCfg.cfg.linkedInLike[actionKey].wit) {
            this.rootCfg.cfg.linkedInLike[actionKey].wit = {};
        }
        this.rootCfg.cfg.linkedInLike[actionKey].wit.run = !!value;
    }

    setActionLikeCounterValue(actionKey, value) {
        const parsed = parseInt(value, 10);
        this.rootCfg.cfg.linkedInLike[actionKey].likeCounterValue = Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
    }

    setActionRangeValue(actionKey, index, value) {
        const parsed = parseInt(value, 10);
        const currentRange = Array.isArray(this.rootCfg.cfg.linkedInLike[actionKey].range)
            ? [...this.rootCfg.cfg.linkedInLike[actionKey].range]
            : [0, 0];
        currentRange[index] = Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
        this.rootCfg.cfg.linkedInLike[actionKey].range = currentRange;
    }

    setRootTimeout(value) {
        const parsed = parseInt(value, 10);
        this.rootCfg.cfg.linkedInLike.rootTimeout = Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
    }

    setRootInterval(value) {
        const parsed = parseInt(value, 10);
        this.rootCfg.cfg.linkedInLike.rootInterval = Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
    }

    save(uid, caller) {
        console.log(getTime() + " CfgState.save() <-" + caller);
        const endPointUrl = DEV_MODE ? API_URL : SAVE_CFG;
        if(uid && uid !== 0){
            axios.post(
                endPointUrl + "saveCfg?uid=" + uid,
                {
                    "cfg": this.rootCfg.cfg,
                    "uid": uid
                },
                {headers: this.authState.authHeader(" CfgState.save() <-" + caller)})
                .then(response => {
                    if (response.status === 200) {
                        this.setRootCfg(
                            response.data,
                            " CfgState.save(), response status 200");
                    } else {
                        console.error("status:" + response.status + ", data:" + response.data);
                    }
                }).catch(reason => {
                    console.error(reason);
                });
        }
    }

    loadFromServiceByUserId(uid, caller) {
        console.log(getTime() + " CfgState.loadFromServiceByUserId() <-" + caller);
        const endPointUrl = DEV_MODE ? API_URL : CFG_BY_USER_ID;
        if(uid && uid !== 0){
            axios
                .get(endPointUrl + "cfgByUserId?uid=" + uid,
                {headers: this.authState.authHeader(" CfgState.loadFromServiceByUserId() <-" + caller)})
                .then((response) => {
                    if (response.status === 200 && response.data && response.data.cfg) {
                        console.log(getTime() + " CfgState.loadFromServiceByUserId(), response status = 200 <-" + caller);
                        this.setRootCfg({
                            "uid" : response.data.uid,
                            "cfg" : response.data.cfg,
                        }, " CfgState.loadFromServiceByUserId(), response status = 200 <-" + caller)
                        this.dataLoaded = true;
                    } else {
                        console.error("status:" + response.status + ", data:" + response.data);
                        this.dataLoaded = true;
                    }
                })
                .catch(reason => {
                    this.dataLoaded = true;
                    console.error(reason);
                });
        }
    }

}
